export default {"src":"/_next/static/media/hexagon-search.4f235282.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};